var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[[_c('font-awesome-icon',{staticClass:"text-center d-block mx-auto loader",attrs:{"icon":"spinner","size":"5x","spin":""}}),_vm._t("default")]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }